import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DrawerService } from 'src/app/services/drawer.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { PackageDataService } from 'src/app/services/package-data.service';
import { PromotionDataService } from 'src/app/services/promotion-data.service';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { getDescription } from 'src/app/enum/Configuration';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
@Component({
  selector: 'app-promotion-simulation',
  templateUrl: './promotion-simulation.component.html',
  styleUrls: ['./promotion-simulation.component.scss']
})
export class PromotionSimulationComponent implements OnInit {
  serviceproviderlist: any
  isCardColorDropdownVisible = false
  istextColorDropdownVisible = false
  isBannerDropdownVisible = false
  is24eastDropdownVisible = false
  slashcolorshow = false
  products: any = []
  selectedCards: any[] = [];
  form: FormGroup
  allproductlist: any;
  productlist
  colors: any = {
    cardBgColor1: '#b302ab',
    cardBgColor2: '#7d32de',
    cardIntensity: 0,
    cardIntensity1: 0,
    cardAngle: 0,
    cardPriceBgColor: '#9a00da',
    cardSpeedBgColor: '#ffffff29',
    promoHeadBgColor1: '#FFFBBA',
    promoHeadBgColor2: '#FCEE21',
    promoHeadIntensity: 0,
    promoHeadIntensity1: 0,
    promoHeadAngle: 0,
    cardButtonBgColor: '#ffffff',
    promoTextColor: '#00008b',
    textPriceColor: '#ffffff',
    textSpeedColor: '#ffffff',
    buttonColor: '#7d32de',
    textSpColor: '#ffffff',
    strikeOutColor: '#b15050'
  };
  imageUrl
  showpromo = true
  showcost = true
  isPortrait: boolean;
  inputWidth: number = 50;
  inputValue: any = 200
  colorMode: string = 'gradient';
  promocolormode: string = 'gradient';
  serviceProviders
  selectedProviders: any = [];
  selectedProducts: any[] = [];
  selectedProductsByProvider: { [provider: string]: any[] } = {};
  promoTextColor: string = this.colors.cardBgColor1;
  promoContent: any;
  promotionId: any;
  promdetails: any;
  fileName: string;
  feeAmount: any;
  serviceProviderFees: any
  twentyEightEastTag
  view: any;
  products1
  addorupdate: any = null
  previousSelection
  constructor(
    public lookupdataservice: LookupDataServiceService,
    public PackageDataService: PackageDataService,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public promotiondataservice: PromotionDataService,
    private drawerService: DrawerService,
    private activatedroter: ActivatedRoute,
    private navigation: NavigationService,
    private toast: NotificationService,
  ) {
    this.activatedroter.params.subscribe((params: any) => {
      this.promotionId = params.id
      this.view = parseInt(params.type)

    })
  }


  ngOnInit(): void {
    this.initform()
    this.getdata()
    // this.toggleProvider('All')
  }

  initform() {
    this.form = this.formBuilder.group({
      serviceproviderId: [1],
    })
  }


  getdata() {
    this.promotiondataservice.getManagePromotionDetailsbyId(this.promotionId).subscribe((result) => {
      this.promdetails = result
      if (this.promdetails.promoProducts.length > 0) {
        this.addorupdate = 2
        this.promdetails.promoProducts = this.promdetails.promoProducts.map(product => ({
          ...product,
          provider: getDescription(product.serviceProviderId)
        }));
      }
      let payload = { PromoSpIds: result.serviceProviderIds, promotionId: this.promotionId }
      this.promoContent = this.promdetails.staticContentName
      this.twentyEightEastTag = this.promdetails.twentyEightEastTag
      this.serviceProviders = payload.PromoSpIds.map(p => getDescription(p))
      this.promotiondataservice.GetSelectedSPProdList(payload).subscribe((result) => {
        this.products = result.productList.map(product => ({
          ...product,
          activationfee: result.activationFee[product.serviceProviderId] || 0,
          installationFee: result.installationFee[product.serviceProviderId] || 0,
          provider: getDescription(product.serviceProviderId)
        }));

        this.products1 = this.products.map(product => ({ ...product }));


        this.serviceProviderFees = this.serviceProviders.reduce((acc, providerName) => {
          const providerId = payload.PromoSpIds.find(id => getDescription(id) === providerName);
          const existingPromoProduct = this.promdetails.promoProducts?.find(p => p.serviceProviderId === providerId);
          acc[providerName] = {
            activationFee: existingPromoProduct?.activationfee ?? result.activationfee?.[providerId] ?? result.activationFee?.[providerId] ?? 0,
            installationFee: existingPromoProduct?.installationFee ?? result.installationFee?.[providerId] ?? 0
          };
          return acc;
        }, {});

        console.log(this.serviceProviderFees);
        this.colors = {
          ...this.colors,
          ...this.promdetails.promoColors[0]
        };
        // this.updateBackground()
        // this.updatepromobackground()
        this.initializeSelectedProducts()
      })
    })
  }



  // feature
  onImageUpload() {
    if (this.imageUrl || this.promdetails.bannerName) {
      this.imageUrl = null
      this.promdetails.bannerName = null
      return
    }

    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    inputElement.accept = 'image/*';  // Restrict to image files
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      debugger
      const files: FileList = (event.target as HTMLInputElement).files;
      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }

      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload one file at a time', 'warning');
        return;
      }

      this.fileName = files.item(0).name;
      const file = files.item(0);

      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        Swal.fire('Warning', 'File size should not exceed 2 MB', 'warning');
        document.body.removeChild(inputElement);
        return;
      }
      // Get file extension and validate if it's an image format
      var fileExtension = this.fileName.slice(
        this.fileName.lastIndexOf('.') + 1
      ).toLowerCase();
      var validImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

      if (!validImageExtensions.includes(fileExtension)) {
        Swal.fire(
          'Warning',
          `Please upload a valid image file (jpg, jpeg, png, gif, bmp, webp)`,
          'warning'
        );
        return;
      }
      document.body.removeChild(inputElement);
      this.imageUrl = await this.convertToBase64(event.target.files[0]);
    });

  }
  convertToBase64(file: any): any {
    return new Promise(async (resolve) => {
      if (file) {
        var reader = new FileReader();
        reader.onload = (readerEvt: any) => {
          var binaryString = readerEvt.target.result;
          resolve('data:image/png;base64,' + btoa(binaryString));
        }
        reader.readAsBinaryString(file);
      }
    })
  }

  showbanner() {
    this.dialog.open(bannercomponent, {
      autoFocus: false,
      disableClose: false,
      backdropClass: 'mat-back-drop',
      // width: "70%",
      // height: "80px",
      data: {
        src: { imageUrl: this.imageUrl ?? null, bannerName: this.promdetails.bannerName ?? null },
        title: 'banner',
        isPortrait: this.isPortrait
      },

    });
  }
  showEditor() {
    const dialogRef = this.dialog.open(bannercomponent, {
      autoFocus: false,
      disableClose: false,
      backdropClass: 'mat-back-drop',
      width: "50%",
      data: {
        editorContent: this.promoContent,
        title: 't&c',
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res != false)
        this.promoContent = res?.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      console.log(this.promoContent, 'promocontent');

    })
  }

  get updateBackground() {
    if (this.colorMode === 'single') {
      return this.colors.cardBgColor1;
    } else {
      return `linear-gradient(${this.colors.cardAngle}deg, ${this.colors.cardBgColor1} 0%, ${this.colors.cardBgColor1} ${this.colors.cardIntensity}%, ${this.colors.cardBgColor2} ${100 - this.colors.cardIntensity1}%, ${this.colors.cardBgColor2} 100%)`;

    }
  }

  get updatepromobackground() {
    if (this.promocolormode == 'single') {
      return this.colors.promoHeadBgColor1;
    } else {
      return `linear-gradient(${this.colors.promoHeadAngle}deg, ${this.colors.promoHeadBgColor1} 0%, ${this.colors.promoHeadBgColor1} ${this.colors.promoHeadIntensity}%, ${this.colors.promoHeadBgColor2} ${100 - this.colors.promoHeadIntensity1}%, ${this.colors.promoHeadBgColor2} 100%)`;

    }
  }

  get updatepromotext() {
    return `-2px 1px 2px ${this.colors.promoTextColor}, -1px -1px 2px ${this.colors.promoTextColor}`;
  }

  // product
  editprice(prod, falg) {
    if (this.view == 2)
      return

    prod.showcost = falg
    if (!falg)
      prod.promotionCost = null
    if (!this.slashcolorshow) {
      this.colors.textPriceColor = this.colorMode == 'single' ? this.colors.cardBgColor1 : this.colors.cardBgColor2
      this.colors.cardPriceBgColor = '#ffffff'
    }
    this.slashcolorshow = this.products.some(prod => prod.showcost === true);

  }

  // Service provider and product filter

  initializeSelectedProducts() {
    debugger

    const groupedProducts: { [provider: string]: any[] } = {};
    this.promdetails.promoProducts = this.promdetails.promoProducts.map(p => {
      let matchingProduct = this.products.find(prod => prod.id === p.productId);


      if (p.promoCost != null) {
        p.showcost = true;
        this.slashcolorshow = true
        p.promotionCost = p.promoCost;
      }

      // If a match is found, replace the product in `this.products`
      if (matchingProduct) {
        Object.assign(matchingProduct, { uploadSpeed: p.uploadSpeed ?? matchingProduct.uploadSpeed, downloadSpeed: p.downloadSpeed ?? matchingProduct.downloadSpeed, promotionCost: p.promotionCost ?? matchingProduct.promotionCost, showcost: p.showcost, ids: p.id, priority: p.priority });
      }
      console.log('matching promo fetch', matchingProduct);

      return matchingProduct

    });

    console.log(this.products);


    this.promdetails.promoProducts.forEach(product => {
      if (!groupedProducts[product.provider]) {
        groupedProducts[product.provider] = [];
      }
      groupedProducts[product.provider].push(product);
    });

    // Initialize selected products
    for (const provider in groupedProducts) {
      this.selectedProductsByProvider[provider] = [...groupedProducts[provider]].sort((a, b) => a.totalAmount - b.totalAmount);
    }
    this.updateSelectedProducts()
  }

  get productsMap() {
    return this.products.reduce((acc, product) => {
      if (!acc[product.provider]) acc[product.provider] = [];
      acc[product.provider].push(product);
      return acc;
    }, {} as Record<string, any[]>);
  }



  getFee(provider: string, type: 'activationFee' | 'installationFee'): number {
    return this.serviceProviderFees?.[provider]?.[type] ?? 0;
  }

  // Function to update the fee when edited
  updateFee(provider: string, type: 'activationFee' | 'installationFee', value: number): void {
    if(this.view == 2)
      return;
    if (this.serviceProviderFees[provider]) {
      this.serviceProviderFees[provider][type] = value;
    }
  }
  // toggleProvider(provider: string) {
  //   debugger;
  //   if (provider === 'All') {
  //     if (!this.selectedProviders.includes('All')) {
  //       this.selectedProviders = ['All'];
  //       this.initializeSelectedProducts();
  //     } else {
  //       this.selectedProviders = [];
  //       this.selectedProducts = [];
  //       this.selectedProductsByProvider = {};
  //     }
  //   } else {
  //     const index = this.selectedProviders.indexOf(provider);
  //     if (index > -1) {
  //       this.selectedProviders.splice(index, 1);
  //       this.selectedProducts = this.selectedProducts.filter(p => p.provider !== provider);
  //       delete this.selectedProductsByProvider[provider];

  //       if (this.selectedProviders.length === 0) {
  //         this.toggleProvider('All');
  //       }
  //     } else {
  //       if (this.selectedProviders.includes('All')) {
  //         this.selectedProviders = [];
  //         this.selectedProducts = [];
  //         this.selectedProductsByProvider = {};
  //       }

  //       this.selectedProviders.push(provider);
  //       const providerProducts = this.products.filter(p => p.provider === provider);
  //       this.selectedProducts = [...this.selectedProducts, ...providerProducts];
  //       this.selectedProductsByProvider[provider] = providerProducts;
  //     }
  //   }

  //   this.updateSelectedProducts();
  // }

  // toggleSelection(grouppedProducts: any): void {
  //   const index = this.selectedCards.indexOf(grouppedProducts);
  //   if (index > -1) {
  //     this.selectedCards.splice(index, 1);  // Remove if already selected
  //   } else {
  //     this.selectedCards.push(grouppedProducts);  // Add to the selection
  //   }
  // }


  // toggleProduct(product: any) {
  //   debugger

  //   const index = this.selectedProducts.findIndex(p => p.product_name === product.product_name);
  //   if (index > -1) {
  //     this.selectedProducts.splice(index, 1);
  //   } else {
  //     this.selectedProducts.push(product);
  //   }
  // }

  setPreviousSelection(provider: string) {
    this.previousSelection = this.selectedProductsByProvider[provider] ? [...this.selectedProductsByProvider[provider]] : [];
  }

  onProductSelectionChange(event: any, provider: string) {
    debugger
    const selectedProducts = event.value;  // Current selection
    const previousSelectedProducts = this.previousSelection;  // Previous selection

    const newlySelectedProduct = selectedProducts.find(p => !previousSelectedProducts.includes(p));


    if (newlySelectedProduct && newlySelectedProduct.isPromo) {
      let txt = '';
      if (newlySelectedProduct.priority) {
        txt = `Promotion is already available for this product and also it have High priority. Do you want to prioritize this?`;
      }
      else {
        txt = `Promotion is already available for this product. Do you want to prioritize this?`;
      }
      const yes = 'Yes'
      const no = 'No'
      Swal.fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: no,
        confirmButtonText: yes,
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
      }).then((result) => {
        const productIndex = event.value.findIndex(p => p.id === newlySelectedProduct.id);

        if (productIndex !== -1)
          event.value[productIndex].priority = result.isConfirmed ? true : false;
      })
    }
    this.selectedProductsByProvider[provider] = event.value.sort((a, b) => a.totalAmount - b.totalAmount);
    console.log(event.value)
    console.log(this.colors);

    this.updateSelectedProducts();
  }

  updateSelectedProducts() {
    this.selectedProducts = Object.values(this.selectedProductsByProvider).flat();
  }


  toggleDrawer() {
    this.drawerService.toggleDrawer();
  }

  // get promotionCostOrDefault() {
  //   return this.groupedProduct.promotionCost !== null && this.groupedProduct.promotionCost !== undefined
  //     ? this.groupedProduct.promotionCost
  //     : 0;
  // }

  // // Setter for updating promotionCost
  // set promotionCostOrDefault(value: any) {
  //   this.groupedProduct.promotionCost = value;
  // }
  save() {
    if (Object.values(this.selectedProductsByProvider).flat().length != 0) {
      let payload = this.promdetails
      payload.addOrUpdate = this.addorupdate
      const selectedProducts = Object.values(this.selectedProductsByProvider).flat();
      const selectedProviders = new Set(selectedProducts.map(p => getDescription(p.serviceProviderId)));

      let missingFees = false;
      selectedProviders.forEach(providerName => {
        const fees = this.serviceProviderFees[providerName];
        if (!fees ||
          fees.activationFee === null || fees.activationFee === undefined || fees.activationFee === '' ||
          fees.installationFee === null || fees.installationFee === undefined || fees.installationFee === '') {
          missingFees = true;
        }
      });

      if (missingFees) {
        this.toast.showError("Please fill in the mandatory fields")
        return;
      }

      const hasInvalidProduct = selectedProducts.some(product =>
        (product.uploadSpeed === '' || product.downloadSpeed === '' || Number.isNaN(product.uploadSpeed) || Number.isNaN(product.downloadSpeed)) ||
        ((product.promotionCost === '' || Number.isNaN(product.promotionCost)) && product.showcost)
      );

      if (hasInvalidProduct) {
        Swal.fire('Warning', 'One or more products have missing values', 'warning');
        return;
      }

      payload.promoProducts = selectedProducts.map(product => {
        const providerName = getDescription(product.serviceProviderId);
        const fees = this.serviceProviderFees[providerName] || { activationFee: 0, installationFee: 0 };
        const originalProduct = this.products1.find(p => p.id == product.id);
        return {
          id: product?.ids,
          productId: product.id,
          promoCode: this.promdetails.promoCode,
          promotionId: this.promdetails.id,
          promoCost: product.promotionCost != null ? product.promotionCost : null,
          uploadSpeed: originalProduct.uploadSpeed != product.uploadSpeed ? product.uploadSpeed : null,
          downloadSpeed: originalProduct.downloadSpeed != product.downloadSpeed ? product.downloadSpeed : null,
          serviceProviderId: product.serviceProviderId,
          activationfee: fees.activationFee,
          installationFee: fees.installationFee,
          priority: product.priority
        };
      });
      if (payload.promoProducts.some(p => (p.promoCost && p.promoCost !== '') && ((p.uploadSpeed && p.uploadSpeed !== '') || (p.downloadSpeed && p.downloadSpeed !== '')))) {
        payload.promotionType = 3;
      } else if (payload.promoProducts.some(p => p.promoCost && p.promoCost !== '')) {
        payload.promotionType = 1;
      } else if (payload.promoProducts.some(p => (p.uploadSpeed && p.uploadSpeed !== '') || (p.downloadSpeed && p.downloadSpeed !== ''))) {
        payload.promotionType = 2;
      }

      payload.promoColors = [this.colors]
      payload.promoColors[0] = {
        ...payload.promoColors[0],
        promotionId: this.promdetails.id
      };
      payload.staticContentName = this.promoContent != '' ? this.promoContent : null
      if (this.imageUrl) {
        let val = this.imageUrl.split(',')
        payload.bannerName = val[1]
      }
      payload.twentyEightEastTag = this.twentyEightEastTag != '' ? this.twentyEightEastTag : null
      console.log('payload', payload);
      this.promotiondataservice.saveManagePromotionDetails(payload).subscribe((result) => {
        if (result) {
          this.toast.showSuccess('Promotion Saved Successfully')
          this.navigation.goToManagePromotion()
        }
      })
    }
    else
      Swal.fire('Warning', 'Please select any product for promotion', 'warning');
  }
  back() {
    this.navigation.goToManagePromotionAdd(this.promotionId, 1)
  }
  restrictNegative(event: any) {
    if (event.key === '-' || event.key === 'e' || event.key === 'E' 
      || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }
}






@Component({
  selector: 'app-banner',
  templateUrl: './banner.html',
  styleUrls: ['./promotion-simulation.component.scss'],
})
export class bannercomponent implements OnInit {
  servicequeue: any = [];
  connectionFeeId: any;
  productId: number;
  connectionFeelist: any;
  promotionImage: any
  editorContent
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<bannercomponent>,
  ) {
    if (this.data.title == 'banner')
      if (this.data.src.imageUrl)
        this.promotionImage = this.data.src.imageUrl
      else
        this.promotionImage = `https://staging.home-connect.co.za/assets/promotionBanner/${this.data.src.bannerName}`

    else if (!this.data.editorContent)
      this.data.editorContent = '<p>* Enter Your Promotion Content Here Line 1..... *</p><p>* Enter Your Promotion Content Here Line 2..... *</p><p>* Enter Your Promotion Content Here Line 3..... *</p>'

  }
  ngOnInit(): void {
    this.checkImageOrientation(this.promotionImage).then(isPortrait => {
      this.data.isPortrait = isPortrait;
      console.log('portrate', isPortrait);

    });
  }

  toolbarModules = {
    toolbar: [
      ['bold', 'italic'],
      ['underline', 'strike'],
      ['code-block', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link'],
      [{ 'align': [] }]
    ]
  };
  checkImageOrientation(imageUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imageUrl;

      img.onload = () => {
        const isPortrait = img.height > img.width;
        resolve(isPortrait);
      };

      img.onerror = (err) => reject(err);
    });
  }

  no() {
    this.dialogRef.close(false)
  };
  getEditorContent() {
    console.log(this.data.editorContent);
    this.dialogRef.close(this.data.editorContent)
  }
}